import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { IConfirmationDialogData } from '../interfaces/IConfirmationDialogData';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  dialog = inject(MatDialog);

  public openConfirmationDialog(confirmationDialogData: IConfirmationDialogData): MatDialogRef<ConfirmationDialogComponent> {
    const ref = this.dialog.open(ConfirmationDialogComponent, {
      data: confirmationDialogData,
      panelClass: 'difa-dialog',
    });
    return ref;
  }
}
